<template>
  <button
    class="btn-audio btn bg-light rounded border-0 text-secondary px-3 bg-opacity-05"
    type="button"
    data-bs-toggle="offcanvas"
    data-bs-target="#AudioPlayerModulOffcanvas"
    aria-controls="AudioPlayerModulOffcanvas"
  >
    <IconComponent :lib="'filoxenia'" :icon="'MusicNote'" class="fs-3" />
    <Equalizer :animation="isPlaying" />
  </button>
</template>
<script setup lang="ts">
import { computed } from "vue";
import Equalizer from "../_shared/dividers/Equalizer.vue";
import IconComponent from "../_shared/icons/icon-component.vue";
import { useAudio } from "@/store/modules/media/audio-list";

const isPlaying = computed(() => useAudio().isPlaying);
</script>
<style lang="scss" scoped>
@import "@/assets/sass/variables.scss";

.btn-audio {
  height: 56px;
  min-width: 103px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;

  transition: all 0.2s ease;

  &:hover {
    background: $secondary !important;
  }
}

.text-secondary {
  &:hover {
    color: $primary !important;
  }
}
</style>
